import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export const MechanismSection = () => {
  return <section className="py-32 px-4 relative overflow-hidden" data-id="element-131">
      <div className="absolute inset-0 bg-radial-gold-strong opacity-40 pointer-events-none" data-id="element-132"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-133">
        <FadeIn data-id="element-134">
          <div className="text-center mb-12" data-id="element-135">
            <span className="text-gold-antique tracking-widest uppercase text-sm font-semibold mb-4 block" data-id="element-136">
              El Mecanismo Único
            </span>
            <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-6 text-brown-espresso" data-id="element-137">
              El Colapso Consciente de la{' '}
              <span className="gold-gradient-text" data-id="element-138">Función de Onda</span>
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-139">
          <div className="relative p-[1px] rounded-2xl bg-gradient-to-b from-gold-antique via-sand to-transparent" data-id="element-140">
            <div className="bg-parchment rounded-2xl p-8 md:p-12 h-full" data-id="element-141">
              <Sparkles className="text-gold-antique mb-6 w-12 h-12" data-id="element-142" />

              <p className="text-xl text-brown leading-relaxed mb-6" data-id="element-143">
                En RENACER, aprendes a retirar tu atención de la "partícula" del
                problema para que este vuelva a ser una onda de probabilidad
                pura.
              </p>

              <div className="h-px w-full bg-gradient-to-r from-transparent via-sand-dark to-transparent my-8" data-id="element-144"></div>

              <p className="text-lg text-brown-warm/70 leading-relaxed" data-id="element-145">
                Al entrar en el{' '}
                <strong className="text-gold-antique font-normal" data-id="element-146">
                  Estado Cero
                </strong>
                , dejas de alimentar tu historia vieja y permites que el campo
                cuántico colapse una nueva línea de tiempo: la de tu Ser
                Iluminado.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};